export const increment = ({ dispatch }) => {
  dispatch('INCREMENT')
}

export const pushModal = ({commit}, {component, props}) => {
  commit('pushModal', {component, props})
}

export const popModal = ({commit}) => {
  commit('popModal')
}

export default {
  pushModal,
  popModal
}


// WEBPACK FOOTER //
// ./lib/brave-vuex/actions.js